<template>
    <div v-if="hasAccess">
        <top-nav-bar goto="/expenses">
            <router-link :to="{ name: 'expenses-edit', params: { expense: $route.params.expense }}" tag="button"
                         class="h-full items-center flex bg-secondary absolute pin-t pin-r mr-2 text-white font-bold font-heading uppercase"
                         v-if="expense && (expense.status.value === 'rejected' || expense.status.value === 'pending')">
                <i class="fas fa-pencil mr-2"></i>
                Edit
            </router-link>
        </top-nav-bar>

        <div v-if="expense" class="py-2 clearfix">
            <h3 class="text-center" v-text="expense.type_name"></h3>

            <list>
                <list-item>
                    <template slot="icon">
                        <i class="text-blue far fa-question-circle"></i>
                    </template>
                    <template slot="title">Current Status</template>
                    <template slot="sub-title">{{expense.status.status}}</template>
                </list-item>

                <component :is="formType" :expense="expense"/>

            </list>

            <list v-if="isAttachments">
                <list-item v-for="(attachment, index) in expense.attachments" :key="'attachment'+index">
                    <template slot="icon">
                        <i class="text-blue fa fa-file"></i>
                    </template>
                    <template slot="title">{{attachment.filename}}</template>
                    <template slot="sub-title">{{formatDate(attachment.created_at, 'D MMM YYYY HH:m')}}</template>
                    <template slot="actions">
                        <a class="btn btn--colored__blue w-full text-center" :href="document_url(attachment)"
                           target="_blank">
                            <i class="far fa-eye"></i>
                        </a>
                    </template>
                </list-item>
            </list>

            <div class="bg-white mb-8">
                <h3 class="py-4 border-b border-grey-light flex items-center justify-center">
                    <span class="mr-2">Comments</span>
                    <button class="btn btn--sm btn--outline__green"
                            v-if="expense && expense.status.value !== 'approved'"
                            @click="addComment">
                        Add comment
                    </button>
                </h3>
                <div v-for="comment in sortedComments" :key="comment.type + comment.id">
                    <div class="relative border-b border-grey-light px-4 pb-4">
                        <div class="flex items-center">
                            <div class="flex-1">
                                <h5>
                                    {{comment.creator.name}}
                                    <span class="font-normal rounded bg-grey-light p-1">
                                        {{comment.creator.type}}
                                    </span>
                                </h5>
                                <div v-if="comment.type !== 'expense'" class="mt-4 flex items-center">
                                    <span class="text-xs p-1 bg-grey text-white rounded"
                                          v-html="showCommentableName(comment)">
                                    </span>
                                </div>
                            </div>
                            <div class="text-xs mr-4" v-text="ago(comment.created_at)"></div>
                        </div>
                        <div class="pt-4 text-sm" v-html="comment.body">

                        </div>
                    </div>
                </div>
            </div>

            <!--
            <div class="block md:inline-flex md:float-right px-4" v-if="expense.is_editable">
                <button class="btn btn&#45;&#45;colored__red w-full" @click="deleteExpense">
                    <i class="fal fa-trash"></i>
                    Delete Expense
                </button>
            </div>
            -->
        </div>
    </div>
</template>

<script>
import InteractsWithDates from '@/mixins/InteractsWithDates';
import CanAccessView from "../mixins/CanAccessView";
import auth from '../auth';
import NeedsExpenseFormTypes from "@/mixins/NeedsExpenseFormTypes";
import MonetaryForm from "@/partials/expenses/show/MonetaryForm";
import MileageForm from "@/partials/expenses/show/MileageForm";
import PerDiemForm from "@/partials/expenses/show/PerDiemForm";
import TimeAllowanceForm from "@/partials/expenses/show/TimeAllowanceForm";

export default {

    mixins: [InteractsWithDates, CanAccessView, NeedsExpenseFormTypes],

    components: {
        MonetaryForm,
        MileageForm,
        PerDiemForm,
        TimeAllowanceForm,
    },

    data() {
        return {
            expense: null,
        }
    },

    computed: {
        formType() {
            let formType = this.formTypes.find(e => e.id === this.expense.type);
            return formType && `${formType.form}Form`;
        },

        sortedComments() {
            return _.sortBy(this.expense.comments, function (comment) {
                return comment.created_at;
            }).reverse();
        },

        isAttachments() {
            return this.expense.attachments && this.expense.attachments.length > 0;
        }
    },

    mounted() {
        this.$api('expenses').get(this.$route.params.expense)
            .then(({data}) => {
                this.expense = data.data;
            });
    },

    methods: {
        document_url(attachment) {
            return `${process.env.VUE_APP_PORTAL}/expenses/attachments/${attachment.id}?api_token=${auth.getToken()}&timestamp=${(new Date()).getTime()}`;
        },

        addComment() {
            if (this.expense && this.expense.status.value === 'approved') {
                return false;
            }

            this.$swal({
                title: 'Add a Comment',
                input: 'textarea',
                confirmButtonText: 'Save',
                showCancelButton: true,
            }).then((body) => {
                body && this.$api('expenses').post(`${this.$route.params.expense}/comments`, {body})
                    .then(({data}) => {
                        this.expense.comments.push(data.data);
                        this.$noty.success('The Comment was successfully saved');
                    })
                    .catch((error) => {
                        if (error.response.data.errors.errorMessage) {
                            this.$noty.error(error.response.data.errors.errorMessage[0]);
                        }
                    });
            }).catch(() => {
            });
        },

        showCommentableName(comment) {
            if (comment.type === 'attachment') {
                return `<strong>Attachment:</strong> ${comment.commentable.filename}`;
            }

            if (comment.type === 'status') {
                return `<strong>Status:</strong> ${comment.commentable.status}`;
            }

            return comment.type;
        },

        /*
        deleteExpense() {
            this.$swal({
                title: 'Are you sure?',
                html: 'This will delete the expense and all of its attachments. The expense will not be reviewed.',
                confirmButtonText: 'Yes, delete expense.',
                showCancelButton: true
            }).then(() => {
                this.$api('expenses').delete(`${this.$route.params.expense}`)
                    .then(() => {
                        this.$router.push('/expenses');
                        this.$noty.success('Expense successfully deleted');
                    });
            }).catch(() => {
                //
            });
        }
        */
    }
}
</script>
